var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10243_143599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 20V2H21.5V11.1C21.3333 11.0667 21.1708 11.0417 21.0125 11.025C20.8542 11.0083 20.6833 11 20.5 11H19.5V4H5.5V18H8.6C8.66667 18.3667 8.75417 18.7167 8.8625 19.05C8.97083 19.3833 9.11667 19.7 9.3 20H3.5ZM5.5 17V18V4V17ZM7.5 16H8.6C8.73333 15.1833 9.025 14.4292 9.475 13.7375C9.925 13.0458 10.5 12.4667 11.2 12H7.5V16ZM7.5 10H11.5V6H7.5V10ZM14.5 21C13.4 21 12.4583 20.6083 11.675 19.825C10.8917 19.0417 10.5 18.1 10.5 17C10.5 15.9 10.8917 14.9583 11.675 14.175C12.4583 13.3917 13.4 13 14.5 13H16.5V15H14.5C13.95 15 13.4792 15.1958 13.0875 15.5875C12.6958 15.9792 12.5 16.45 12.5 17C12.5 17.55 12.6958 18.0208 13.0875 18.4125C13.4792 18.8042 13.95 19 14.5 19H16.5V21H14.5ZM13.5 10H17.5V6H13.5V10ZM14.5 18V16H20.5V18H14.5ZM18.5 21V19H20.5C21.05 19 21.5208 18.8042 21.9125 18.4125C22.3042 18.0208 22.5 17.55 22.5 17C22.5 16.45 22.3042 15.9792 21.9125 15.5875C21.5208 15.1958 21.05 15 20.5 15H18.5V13H20.5C21.6 13 22.5417 13.3875 23.325 14.1625C24.1083 14.9375 24.5 15.8833 24.5 17C24.5 18.1 24.1083 19.0417 23.325 19.825C22.5417 20.6083 21.6 21 20.5 21H18.5Z",
    fill: "#5D75F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10243_143599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferalLink);
export default __webpack_public_path__ + "static/media/ReferalLink.4fd6cf4aed2d96527fdce1352b7bd18a.svg";
export { ForwardRef as ReactComponent };